"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _of = require("rxjs/observable/of");

var _mergeMap = require("rxjs/operators/mergeMap");

var _selectors = require("settings-ui-sdk/LanguageSettings/selectors");

var _StagingActions = require("../actions/StagingActions");

var _default = function _default($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_StagingActions.StagingActionTypes.CLEAR_STAGED_CHANGES).pipe((0, _mergeMap.mergeMap)(function () {
    var currentSettings = (0, _selectors.getLanguageSettings)(getState());
    return (0, _of.of)((0, _StagingActions.replaceStagedLanguageSettingsChanges)(currentSettings));
  }));
};

exports.default = _default;
module.exports = exports.default;